var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Actions, ofActionDispatched, Select, Store } from '@ngxs/store';
import { BehaviorSubject, Observable } from 'rxjs';
import { DeleteShareableLink, LinkCopySuccess, LoadShareableLink, ResetShareLinkState, ShareLinkState, ToggleOptionsPanel } from '../links/share-link.state';
import { Settings } from 'common/core/config/settings.service';
import copy from 'copy-to-clipboard';
import { BaseDialog } from 'common/core/ui/dialogs/base-dialog';
import { Toast } from 'common/core/ui/toast.service';
import { shareLinkSocially } from '../../../../common/core/utils/share-link-socially';
var ShareLinkDialogComponent = /** @class */ (function (_super) {
    __extends(ShareLinkDialogComponent, _super);
    function ShareLinkDialogComponent(store, toast, actions$, settings, dialogRef) {
        var _this = _super.call(this) || this;
        _this.store = store;
        _this.toast = toast;
        _this.actions$ = actions$;
        _this.settings = settings;
        _this.dialogRef = dialogRef;
        _this.shareableLink$ = new BehaviorSubject(null);
        return _this;
    }
    ShareLinkDialogComponent.prototype.ngOnInit = function () {
        this.store.dispatch(new LoadShareableLink());
        this.bindToOptionsPanelToggle();
    };
    ShareLinkDialogComponent.prototype.ngAfterViewInit = function () {
        this.bindToLinkChange();
    };
    ShareLinkDialogComponent.prototype.ngOnDestroy = function () {
        this.store.dispatch(new ResetShareLinkState());
    };
    ShareLinkDialogComponent.prototype.toggleOptionsPanel = function () {
        this.store.dispatch(new ToggleOptionsPanel());
    };
    ShareLinkDialogComponent.prototype.deleteLink = function () {
        var _this = this;
        this.store.dispatch(new DeleteShareableLink()).subscribe(function () {
            _this.toast.open('Link deleted.');
            _this.dialogRef.close();
        });
    };
    ShareLinkDialogComponent.prototype.copyLinkToClipboard = function () {
        this.focusInput();
        var success = copy(this.shareableLink$.value);
        if (success) {
            this.store.dispatch(new LinkCopySuccess());
        }
    };
    ShareLinkDialogComponent.prototype.bindToLinkChange = function () {
        var _this = this;
        this.link$.subscribe(function (link) {
            if (!link)
                return;
            _this.shareableLink$.next(_this.settings.getBaseUrl() + 'drive/s/' + link.hash);
            setTimeout(function () { return _this.focusInput(); });
        });
    };
    ShareLinkDialogComponent.prototype.bindToOptionsPanelToggle = function () {
        var _this = this;
        var sub = this.actions$.pipe(ofActionDispatched(ToggleOptionsPanel))
            .subscribe(function () {
            // close dialog if user canceled link creation
            if (!_this.store.selectSnapshot(ShareLinkState.optionsVisible) && !_this.shareableLink$.value) {
                _this.close();
            }
        });
        this.addSubs(sub);
    };
    ShareLinkDialogComponent.prototype.shareLink = function (network) {
        shareLinkSocially(network, this.shareableLink$.value);
    };
    ShareLinkDialogComponent.prototype.focusInput = function () {
        var input = document.getElementById('link-input');
        input.focus();
        input.select();
    };
    __decorate([
        Select(ShareLinkState.loading),
        __metadata("design:type", Observable)
    ], ShareLinkDialogComponent.prototype, "loading$", void 0);
    __decorate([
        Select(ShareLinkState.link),
        __metadata("design:type", Observable)
    ], ShareLinkDialogComponent.prototype, "link$", void 0);
    __decorate([
        Select(ShareLinkState.optionsVisible),
        __metadata("design:type", Observable)
    ], ShareLinkDialogComponent.prototype, "optionsVisible$", void 0);
    return ShareLinkDialogComponent;
}(BaseDialog));
export { ShareLinkDialogComponent };
